import User from '@/models/User'
import * as MutationTypes from '@/store/mutation-types'

const state = {
  session: {
    currentUser: null,
    loggedIn: false,
    token: ''
  }
}

const getters = {
  currentUser: state => state.session.currentUser,
  loggedIn: state => state.session.loggedIn,
  token: state => state.session.token
}

const mutations = {
  [MutationTypes.LOGIN] (state, token) {
    state.session.currentUser = User.from(token)
    state.session.loggedIn = true
    state.session.token = token
  },
  [MutationTypes.LOGOUT] (state) {
    state.session.currentUser = null
    state.session.loggedIn = false
    state.session.token = ''
  }
}

const actions = {
  login ({ commit }, token) {
    commit(MutationTypes.LOGIN, token)
  },

  logout ({ commit }) {
    commit(MutationTypes.LOGOUT)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
